export enum Error500LocalizationId {
    ErrorTitle = "error-500.error_title",
    ErrorDescription = "error-500.error_description",
    ContactUsLink = "error-500.contact_us_link",
    BackButton = "error-500.back_button",
    Image = "error-500.error_image",
}
